


export enum AuthStatus {
  checking = 'checking',
  authenticated = 'authenticated',
  unAuthenticated = 'unauthenticated'
}
